/* eslint-disable quote-props */

const Bio_AttentionToModeling =
  'Creating, revising, and using models allows key patterns, ' +
  'interactions, and relationships in biological systems to emerge.';
const Bio_StrategicUseMath =
  'Strategic use of mathematics allows for effective analysis and interpretation of experimental data.';
const BioChem_AnalyticalReading =
  'Analytical reading and writing increases opportunities to gain, retain, and apply ' +
  'scientific knowledge and to carry out scientific argumentation.';

const Chem_AttentionToModeling =
  'Developing and refining models allows for connections between macroscopic observations ' +
  'and the structure, motion, and interactions occurring at the atomic scale.';
const Chem_StrategicUseMath =
  'Integrating mathematics with conceptual understanding helps model chemical phenomena.';

const AlgGeo_AuthenticityApplications =
  'Creating mathematical models and solving authentic problems scenarios provides ' +
  'opportunities to see how mathematics is used to make sense of the world.';
const AlgGeo_Engagement =
  'Using evidence to craft arguments develops critical reasoning writing skills in mathematics.';
const AlgGeo_ConnectionsReps =
  'Connecting mathematics concepts through multiple representations deepens mathematical understanding.';

const Eng_CriticalReading =
  'The questions in this category focus on your ability to comprehend a wide range of texts, ' +
  'including graphs and charts. Questions may ask about information or ideas that are explicitly stated or that require ' +
  'you to make an inference based on textual evidence. Questions may also include using context clues to infer the ' +
  'meaning of multiple-meaning or unfamiliar words.';
const Eng_Analysis =
  'The questions in this category focus on analyzing the development of an argument or ' +
  'analyzing literary elements in a work of fiction, drama, or poetry. Questions may ask about rhetorical features of ' +
  'an argument or a writer’s use of literary and stylistic elements in literature.';
const Eng_WritingRevision =
  'Questions in this category focus on revising and editing an argument or literary analysis. ' +
  'Questions may ask about establishing a central claim, selecting and incorporating evidence, organizing ideas effectively, ' +
  'and revising language for precision, consistency, and clarity.';
const Eng_ConventionsEnglish =
  'Questions in this category focus on communicating clearly by revising and editing ' +
  'language to ensure sentences are grammatically correct and that their internal structures provide clarity. ' +
  'Questions may address conventions such as subject/verb agreement, appropriate verb tense, coordinating and ' +
  'subordinating conjunctions, and parallel structure.';

const WHG_EvaluatingEvidence =
  'Questions in this category require you to draw evidence directly from the ' +
  'provided source (passage, map, image, etc.).';
const WHG_EvidencePlusHistoricalRelationships =
  'Questions in this category require you to draw evidence directly from the provided ' +
  'source AND apply your knowledge of key concepts from history or geography.';
const WHG_HistoricalRelationships =
  'Questions in this category require you to rely solely on your knowledge of ' +
  'key concepts from history or geography.';

const focusDescriptions = {
  107: {
    // World History and Geography
    '1 (Analyzing Sources Only)': WHG_EvaluatingEvidence,
    '2 (Analyzing Sources + Disciplinary Reasoning)':
      WHG_EvidencePlusHistoricalRelationships,
    '3 (Disciplinary Reasoning Only)': WHG_HistoricalRelationships,
  },
  104: {
    // Algebra
    'Connections among multiple representations': AlgGeo_ConnectionsReps,
    'Greater authenticity of applications and modeling':
      AlgGeo_AuthenticityApplications,
    'Engagement in mathematical argumentation': AlgGeo_Engagement,
  },
  115: {
    // Algebra 2
    'Connections among multiple representations': AlgGeo_ConnectionsReps,
    'Greater authenticity of applications and modeling':
      AlgGeo_AuthenticityApplications,
    'Engagement in mathematical argumentation': AlgGeo_Engagement,
  },
  114: {
    // Geometry
    'Connections among multiple representations': AlgGeo_ConnectionsReps,
    'Greater authenticity of applications and modeling':
      AlgGeo_AuthenticityApplications,
    'Engagement in mathematical argumentation': AlgGeo_Engagement,
  },
  106: {
    // English 1
    'Critical Reading': Eng_CriticalReading,
    Analysis: Eng_Analysis,
    'Writing and Revision': Eng_WritingRevision,
    'Conventions of Standard English': Eng_ConventionsEnglish,
  },
  112: {
    // English 2
    'Critical Reading': Eng_CriticalReading,
    Analysis: Eng_Analysis,
    'Writing and Revision': Eng_WritingRevision,
    'Conventions of Standard English': Eng_ConventionsEnglish,
  },
  105: {
    // Biology
    'Attention to modeling': Bio_AttentionToModeling,
    'Strategic use of mathematics': Bio_StrategicUseMath,
    'Emphasis on analytical reading and writing': BioChem_AnalyticalReading,
  },
  113: {
    // Chemistry
    'Attention to modeling': Chem_AttentionToModeling,
    'Strategic use of mathematics': Chem_StrategicUseMath,
    'Emphasis on analytical reading and writing': BioChem_AnalyticalReading,
  },
};

const getStudentDescription = (subject, tag) => {
  const subjectId = parseInt(subject, 10);
  return focusDescriptions[subjectId][tag];
};

export default getStudentDescription;
/* eslint-enable quote-props */
